import {
    GET_PROFILE_SUCCESS,
    GET_PROFILE_FAIL,
    UPDATE_PROFILE_SETVAR
} from "./action"
const initialState = {
    lastName: "",
    firstName: "",
    email: "",
    avatar: "",
    phone: "",
    address: ""
}
export default function (state = initialState, action) {
    switch (action.type) {
        case GET_PROFILE_SUCCESS:
            return {
                ...action.payload
            }
        case GET_PROFILE_FAIL:
            return { ...state }
        case UPDATE_PROFILE_SETVAR:
            let {
                key,
                value
            } = action.payload

            let newState = null
            if (key) {
                newState = state
                newState[key] = value
            } else {
                newState = value
            }

            return { ...newState }
        default: return { ...state }
    }
}


// WEBPACK FOOTER //
// ./src/components/user/setting/reducer.js